const APIKEY = 'XuovqRjTERWCSb9oY2n61M0ADuowDdJAFEWeG4Cx48b4b9a5';
const APIURL = 'https://calc.pro.by';
// const APIURL = 'http://127.0.0.1:3030';

// CALCULATOR
const range = document.querySelector("#prepaid_expense_range")
const rangeMonth = document.querySelector("#range-month")
const input = document.querySelector(".procent-input")
const inputMonth = document.querySelector(".month-input")

range?.addEventListener("input", (event) => {
    const tempInput = event.target.value;
    input.value = tempInput;
})

range?.addEventListener("change", (event) => {
    let CustomEvent = new Event("change");
    input.dispatchEvent(CustomEvent);
})

input?.addEventListener('change', () => {
    const tempInput = input.value;
    range.value = tempInput
})

rangeMonth?.addEventListener("input", (event) => {
    const tempInput = event.target.value;
    inputMonth.value = tempInput;
})

rangeMonth?.addEventListener("change", (event) => {
    let CustomEvent = new Event("change");
    inputMonth.dispatchEvent(CustomEvent);
})

inputMonth?.addEventListener('change', () => {
    const tempInput = input.value;
    rangeMonth.value = tempInput
})


let calcSwitches = document.querySelectorAll(".calcultor-switch-box")
let yearSection = document.querySelector(".year")

calcSwitches.forEach(switchBox => {
    if(window.lockObjectOfLeasing && window.lockObjectOfLeasing != 1) {
        return
    }
    switchBox?.addEventListener("click", ({ target }) => {
        if (target.classList.contains("calcultor-switch")) {
            switchBox.querySelectorAll(".calcultor-switch").forEach((swicth) => {
                swicth.classList.remove("calcultor-switch--active");
                swicth.querySelector('input[type="radio"]').checked = false
            })
            target.classList.add("calcultor-switch--active")
            target.querySelector('input[type="radio"]').checked = true
        }

        if (target.getAttribute("value") === "new") {
            yearSection.classList.add("yearDisabled")
            yearSection.querySelector(".year-select").disabled = true;
        }

        if (target.closest(".state-switch") && !(target.getAttribute("value") === "new")) {
            yearSection.classList.remove("yearDisabled")
            yearSection.querySelector(".year-select").disabled = false;
        }

        let event = new Event("change");
        target.dispatchEvent(event);

    })
})


let currensySelect = document.querySelector(".currency-select");
let currencies = document.querySelectorAll(".currencies")
currensySelect?.addEventListener("change", () => {
    currencies.forEach(item => item.innerHTML = currensySelect.value)
})

// OPEN GRAPH MODAL

let paidGgraphBtn = document.querySelector(".paid-graph");
let graphBox = document.querySelector(".graph-modal");
let closeGraphBoxBtn = document.querySelector(".close-graph");

paidGgraphBtn?.addEventListener("click", () => {
    graphBox.classList.remove("dnone");
    noScrollBody()

});

closeGraphBoxBtn?.addEventListener("click", () => {
    graphBox.classList.add("dnone");
    removeNoScrollBody()
});

graphBox?.addEventListener("click", (event) => {
    if (!(event.target.closest(".graph-modal__box"))) {
        graphBox.classList.add("dnone");
        removeNoScrollBody()
    }
})

function noScrollBody() {
    document.body.classList.add("noscroll");
}

function removeNoScrollBody() {
    document.body.classList.remove("noscroll");
}



const lessee = document.querySelectorAll('input[name="lessee"]');
var objectOfLeasing = document.querySelector('select[name="objectOfLeasing"]');
if (!objectOfLeasing) {
  objectOfLeasing = document.querySelector('input[name="objectOfLeasing"]');
}
const calculator_image = document.getElementById('calculator-image');
const condition = document.querySelectorAll('input[name="condition"]');
const age = document.querySelector('select[name="age"]');
const price = document.querySelector('#price');
const currency = document.querySelector('select[name="currency"]');
const prepaid_expense = document.querySelector('#prepaid_expense');
const prepaid_expense_label = document.querySelector('#prepaid_expense_label');
const prepaid_expense_sum = document.querySelector('#prepaid_expense_sum');
const lease_term = document.querySelector('#lease_term');
const lease_term_label = document.querySelector('#lease_term_label');


// const objectOfLeasing = document.querySelector('select[name="objectOfLeasing"]');
var calculatorConfig = null;
var startCalculations = false;

var activeLessee = 'business';
var activeCondition = 'new';
var activeConditionKey = 1;
var activeCurrency = window.baseCurrency ? window.baseCurrency : 'USD';
var activeObjectsOfLeasing = null;
var activePrepaidExpense = 10;
const isNeedStartCalculation = window.baseCurrency != undefined;

async function fetchData() {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", APIURL + "/api/calculator/config");
    xhr.setRequestHeader('Authorization', 'Bearer ' + APIKEY);

    xhr.send();
    xhr.onload = function () {
        calculatorConfig = JSON.parse(xhr.response);
        setTimeout(() => {
            initCalculator().then(() => {
                startCalculations = true
                updateCalculation()
            })
        }, 100)

    };
}

async function initCalculator() {
    initObjectOfLeasing()
    initAge()
    initCondition()
    initPrice(true)
    initPrepaidExpense(true)
    initLeaseTerm(true)
}

function initObjectOfLeasing() {
    if (objectOfLeasing.nodeName == 'SELECT') {
        objectOfLeasing.innerHTML = '';
        var obj = calculatorConfig[activeLessee].ObjectsOfLeasing;
        for (var key in obj) {
          if (!activeObjectsOfLeasing) {
            activeObjectsOfLeasing = key;
          }
          var option = document.createElement('option');
          option.value = key;
          option.innerHTML = obj[key].name;
          objectOfLeasing.appendChild(option);
        }
        var active = objectOfLeasing.value;
        
        if(!window.lockImage) {
            calculator_image.src = obj[active].image.replace('https://calc.pro.by//storage/https:', 'https:');
        }
      } else {
        activeObjectsOfLeasing = objectOfLeasing.value;
      }
}
function initCondition() {
    activeCondition = document.querySelector('input[name="condition"]:checked').value;

    let carAge = (new Date().getFullYear()) - age.value;
    let ages = calculatorConfig[activeLessee].ObjectsOfLeasing[activeObjectsOfLeasing].ages
    let keys = Object.keys(ages);
    let lastKey = keys[keys.length - 1];
    for (let key in ages) {
        let item = ages[key];
        if (activeCondition == 'new' && item.is_new == 1) {
            activeConditionKey = item.leasing_attributes_id;
            break;

        } else if ((activeCondition != 'new' && item.is_new != 1 && carAge <= item.age_to && carAge >= item.age_from) || lastKey === key) {
            activeConditionKey = item.leasing_attributes_id;
            break;
        }
    }
}
function initAge() {
    age.innerHTML = '';
    let ageMax = calculatorConfig[activeLessee].ageMax
    let ageMin = calculatorConfig[activeLessee].ageMin
    if(window.carAge && window.carAge < ageMin) {
        ageMin = window.carAge
    }
    while (ageMin <= ageMax) {
        let option = document.createElement('option')
        option.value = ageMax
        option.innerHTML = ageMax

        age.appendChild(option)
        --ageMax;
    }
    if(window.carAge) {
        age.value = window.carAge
        // window.carAge = null
    }
}

function initPrice(changeValue = false) {
    let obj = calculatorConfig[activeLessee].prices
    price.setAttribute("min", obj[activeCurrency].costMin);
    price.setAttribute("max", obj[activeCurrency].costMax);

    if (window.basePrice && changeValue == true) {
        price.value = window.basePrice
        price.dispatchEvent(new Event('change'))
      } else {
        if (changeValue || price.value < obj[activeCurrency].costMin) {
          price.value = changeValue && obj[activeCurrency].costMin < 2000 ? 2000 : obj[activeCurrency].costMin;
        }
        if (price.value > obj[activeCurrency].costMax) {
          price.value = obj[activeCurrency].costMax;
        }
      }
      price.dispatchEvent(new Event('change-custom'))

}

function initPrepaidExpense(changeValue = false) {
    let objConditions = calculatorConfig[activeLessee].ObjectsOfLeasing[activeObjectsOfLeasing].Conditions[activeConditionKey]

    let keyFrom = Object.keys(objConditions)[0]
    let keyTo = Object.keys(objConditions)[Object.keys(objConditions).length - 1]
    let min = objConditions[keyFrom].min_advance_payment_from
    let max = objConditions[keyTo].min_advance_payment_to
    let type_of_payments = document.querySelector('input[name=type_of_payments]:checked').value;
    if(type_of_payments !== 'equal') {
        min = objConditions[keyFrom].min_advance_payment_from_decreasing
        max = objConditions[keyTo].min_advance_payment_to_decreasing
    }

    prepaid_expense.setAttribute("min", min)
    prepaid_expense.setAttribute("max", max)
    prepaid_expense_label.innerHTML = 'от ' + min + ' до ' + max

    range.setAttribute("min", min)
    range.setAttribute("max", max)

    if (changeValue || prepaid_expense.value < min) {
        if(window.basePrePaid) {
            min = window.basePrePaid
            window.basePrePaid = null
        }
        prepaid_expense.value = min
        range.value = min
        activePrepaidExpense = min
    } else if (prepaid_expense.value > max) {
        prepaid_expense.value = max
        range.value = max
        activePrepaidExpense = max
    }

    prepaid_expense_sum.value = Math.round(price.value * (prepaid_expense.value / 100), 2)
    range.value = prepaid_expense.value

    let inputValueSize = prepaid_expense_sum.value.length;
    prepaid_expense_sum.style.width = inputValueSize * 10 + 'px';

    if(typeof updateFormatedNumberTo !== "undefined") {
        updateFormatedNumberTo(prepaid_expense_sum)
    }

}

function initLeaseTerm(changeValue = false) {
    let obj = calculatorConfig[activeLessee].ObjectsOfLeasing[activeObjectsOfLeasing].Conditions[activeConditionKey]
    let keys = Object.keys(obj);
    let lastKey = keys[keys.length - 1];
    for (let key in obj) {
        let elem = obj[key]
        const type_of_payments = document.querySelector('input[name=type_of_payments]:checked').value;
        const min_advance_payment_from = type_of_payments === 'equal' ? elem.min_advance_payment_from  : elem.min_advance_payment_from_decreasing;
        const min_advance_payment_to = type_of_payments === 'equal' ? elem.min_advance_payment_to  : elem.min_advance_payment_to_decreasing;

        if ((min_advance_payment_from <= prepaid_expense.value && min_advance_payment_to > prepaid_expense.value) || lastKey === key) {
            let type_of_payments = document.querySelector('input[name=type_of_payments]:checked').value;
            let maxTerm = validateMaxLeaseTerm(type_of_payments == 'equal' ? elem.max_term_months_equal : elem.max_term_months_decreasing)
            lease_term.setAttribute("max", maxTerm)
            rangeMonth.setAttribute("max", maxTerm)
            if (changeValue || lease_term.value > maxTerm) {
                lease_term.value = maxTerm
                rangeMonth.value = maxTerm
            } else if (lease_term.value < 12) {
                lease_term.value = 12
                rangeMonth.value = 12
            }

            lease_term_label.innerHTML = 'от 12 до ' + maxTerm;
            break;
        }
    }

    let inputValueSize = lease_term.value.length;
    if (lease_term.value.length > 2) {
        lease_term.value =  maxTerm
    }
    lease_term.style.width = inputValueSize * 10 + 'px';
    lease_term.style.maxWidth = 20 + 'px';
}

function validateMaxLeaseTerm(maxVal) {
    if (maxVal > 300) {
        return 300;
    }
    return maxVal
}

fetchData()

lessee?.forEach(element => {
    element.addEventListener('change', updateLessee)
});
function updateLessee(e) {
    activeLessee = e.target.value
    initCalculator()
}

objectOfLeasing.addEventListener('change', updateObjectOfLeasing);
function updateObjectOfLeasing(e) {
    activeObjectsOfLeasing = objectOfLeasing.value;
    if(!window.lockImage) {
        calculator_image.src = calculatorConfig[activeLessee].ObjectsOfLeasing[activeObjectsOfLeasing].image.replace('https://calc.pro.by//storage/https:', 'https:');
    }
}

currency.addEventListener('change', updateCurrency);
function updateCurrency(e) {
    activeCurrency = currency.value;
}

prepaid_expense.addEventListener('change', updatePrepaidExpense);
function updatePrepaidExpense(e) {
    activePrepaidExpense = prepaid_expense.value;
    prepaid_expense_sum.value = Math.round(price.value * (prepaid_expense.value / 100), 2);
}
prepaid_expense_sum.addEventListener('change', updatePrepaidExpenseSum)
function updatePrepaidExpenseSum() {
    activePrepaidExpense = Math.round(prepaid_expense_sum.value * 100 / price.value, 2)
    prepaid_expense.value = activePrepaidExpense
}
lease_term.addEventListener('change', moveRangerlease_term)
function moveRangerlease_term() {
    rangeMonth.value = lease_term.value
}

objectOfLeasing.addEventListener('change', reinitValues)
age.addEventListener('change', reinitValues);
currency.addEventListener('change', (e) => {
    currencysConverter(e);
    reinitValues(e)
});
price.addEventListener('change', reinitValues);
prepaid_expense_sum.addEventListener('change', reinitValues);
prepaid_expense.addEventListener('change', reinitValues);
lease_term.addEventListener('change', reinitValues);
document.querySelectorAll('input[name="type_of_payments"]')?.forEach(element => {
    element.addEventListener('change', reinitValues);
});
document.querySelectorAll('input[name="condition"]')?.forEach(element => {
    element.addEventListener('change', reinitValues);
});
function reinitValues(e) {
    initCondition();
    // initAge();
    initPrice();
    initPrepaidExpense();
    initLeaseTerm();
    // updateInputSizes();
}

lessee?.forEach(element => {
    element.addEventListener('change', updateCalculation)
});


const formCalculator = document.querySelector('#calculatorForm');
const priceMWrap1 = document.querySelector('#calc-month-1');
const priceMWrap2 = document.querySelector('#calc-month-2');
const priceMWrap3 = document.querySelector('#calc-month-3');
var blockRequest = false;

objectOfLeasing.addEventListener('change', updateCalculation);
age.addEventListener('change', updateCalculation);
currency.addEventListener('change', updateCalculation);
price.addEventListener('change', updateCalculation);
prepaid_expense_sum.addEventListener('change', updateCalculation);
prepaid_expense.addEventListener('change', updateCalculation);
lease_term.addEventListener('change', updateCalculation);
document.querySelectorAll('input[name="condition"]')?.forEach(element => {
    element.addEventListener('change', updateCalculation);
});
document.querySelectorAll('input[name="type_of_payments"]')?.forEach(element => {
    element.addEventListener('change', updateCalculation);
});

const graphList = document.getElementById('graph-list');
const graphType = document.getElementById('graph-type');
function updateCalculation() {
    if (blockRequest || !startCalculations) {
        return;
    }
    blockRequest = true;
    let xhr = new XMLHttpRequest();
    const queryString = new URLSearchParams(new FormData(formCalculator)).toString()
    xhr.open("GET", APIURL + "/api/calculator/calculateData?" + queryString);
    xhr.setRequestHeader('Authorization', 'Bearer ' + APIKEY);

    xhr.send();
    xhr.onload = function () {
        blockRequest = false;
        let data = JSON.parse(xhr.response)

        priceMWrap1.innerHTML = data.result[1].display['Сумма к оплате']
        priceMWrap2.innerHTML = data.result[2].display['Сумма к оплате']
        priceMWrap3.innerHTML = data.result[3].display['Сумма к оплате']

        graphList.innerHTML = ''
        for (let period in data.result) {
            let item = data.result[period]

            if (!item.display) {
                continue;
            }

            let graphList__item = document.createElement('div')
            graphList__item.classList.add('graph-list__item')

            let graphList__month = document.createElement('p')
            graphList__month.classList.add('graph-list__month')
            graphList__month.innerHTML = period == 0 ? 'Аванс' : period + '-й месяц'

            let divWrapp = document.createElement('div')

            let graphList__value = document.createElement('p')
            graphList__value.classList.add('graph-list__value')
            graphList__value.innerHTML = item['display']['Сумма к оплате']
            let span_currency = document.createElement('span')
            span_currency.innerHTML = ' ' + currency.value

            divWrapp.appendChild(graphList__value)
            divWrapp.appendChild(span_currency)

            graphList__item.appendChild(graphList__month)
            graphList__item.appendChild(divWrapp)


            graphList.appendChild(graphList__item)
        }
        let isEqual = document.getElementById('equal-pay-switch').checked;
        graphType.innerHTML = isEqual ? 'Равный платеж' : 'Убывающий платеж'

    };
}




// send form
var isCalculatorSubmit = false;
const submitButton = formCalculator.querySelector('button.cta');
const formOnPage = document.querySelector('form.sendToAction');
const lidForm = document.getElementById('lid-form');
submitButton.addEventListener('click', function (e) {
    e.preventDefault();
    isCalculatorSubmit = true;
});

document.querySelectorAll('.request-leasing')?.forEach(element => {
    element.addEventListener('click', checkOpenPopup)
})
function checkOpenPopup(e) {
    removeCalculatorFields()
    if (isCalculatorSubmit) {
        addCalculatorFields()
    }
    isCalculatorSubmit = false;
}

function addCalculatorFields() {
    let baseDiv = document.createElement('div')
    baseDiv.classList.add('form-popup-calculator-fields')

    let formDataVal = new FormData(formCalculator)
    for (var p of formDataVal) {
        let name = p[0];
        let value = p[1];
        if (name == '_token') continue;
        if(name == 'sendTo') {
            lidForm.action = value;
            lidForm.classList.add('sendToAction');
        }

        let calcInput = document.createElement('input')
        calcInput.setAttribute('type', 'hidden')
        calcInput.setAttribute('name', name)
        calcInput.value = value

        baseDiv.appendChild(calcInput)
    }

    if(window.basePrice < 8000 || window.partner_id == 6) {
        let calcInput = document.createElement('input')
        calcInput.setAttribute('type', 'hidden')
        calcInput.setAttribute('name', 'sendToOtherMail')
        calcInput.value = '1'

        baseDiv.appendChild(calcInput)
    }
    lidForm.appendChild(baseDiv)
}

function removeCalculatorFields() {
    let fields = document.querySelector('.form-popup-calculator-fields')
    fields?.remove()
}

// EDIT INPUT SIZE

const prepaidInput = document.querySelector(".prepaid-input");
const procentInput = document.querySelector(".procent-input");
const monthInput = document.querySelector(".month-input");
const priceInput = document.querySelector("#price");

prepaidInput.addEventListener("input", (event) => {
    if (event.target.value.length > 8) {
        event.target.value = 99999999
    }
    let inputValueSize = event.target.value.length;
    event.target.style.width = inputValueSize * 10 + 'px';

});


procentInput.addEventListener("input", (event) => {
  let inputValueSize = event.target.value.length;
  if (event.target.value.length > 2) {
    event.target.value = 99
  }
  event.target.style.width = inputValueSize * 10 + 'px';
  event.target.style.maxWidth = 20 + 'px';  
});

monthInput.addEventListener("input", (event) => {
    let inputValueSize = event.target.value.length;
    if (event.target.value.length > 2) {
      event.target.value = 99
    }
    event.target.style.width = inputValueSize * 10 + 'px';
    event.target.style.maxWidth = 20 + 'px';  
  });

priceInput.addEventListener("input", (event) => {
    if (event.target.value.length > 6) {
        event.target.value = 999999
    }
})


function editInputSize(event) {
    let inputValueSize = event.target.value.length;
    event.target.style.width = inputValueSize * 10 + 'px';
    event.target.style.maxWidth = 70 + 'px';
}

// currency change
const addditionalCurrencyWrapp = document.getElementById('addditionalCurrencyWrapp');
var currencysRates = {
    'USD': 0,
    'EUR': 0,
    'BYN': 1
}
var oldCurrency = 'BYN';
var origFullValue = null;
async function initRates() {
    currencysRates.USD = await getLatesRates(431).then(rate => currencysRates.USD = rate) // usd
    currencysRates.EUR = await getLatesRates(451).then(rate => currencysRates.EUR = rate) // eur
    if(!isNeedStartCalculation) {
        return;
    }
    
    if(!startCalculations) {
        var intervalConverter = setInterval(() => {
            if(startCalculations && !blockRequest) {
                currencysConverter(null)
                clearInterval(intervalConverter)
            }
        })
    } else {
        currencysConverter(null)
    }
    
}
async function getLatesRates(Cur_ID) {
    let url = 'https://api.nbrb.by/exrates/rates/' + Cur_ID;
    let response = await fetch(url);
    let countryData = await response.json();
    return countryData.Cur_OfficialRate;
}
document.querySelector('.currency-select')?.addEventListener('focus', () => { oldCurrency = currency.value })
document.querySelector('.currency-select')?.addEventListener('click', () => { oldCurrency = currency.value })
price?.addEventListener('change', (e) => {origFullValue = null})
function currencysConverter(e) {
    if(currencysRates[oldCurrency] == 0 || currencysRates[activeCurrency] == 0) {
        return;
    }
    
    let priceValue = origFullValue !== null ? origFullValue : price.value
    if(oldCurrency != 'BYN' || activeCurrency == 'BYN') {
        priceValue *= currencysRates[oldCurrency]
    }
    if(activeCurrency != 'BYN') {
        priceValue /= currencysRates[activeCurrency]
    }
    price.value = priceValue.toFixed(2)
    price.dispatchEvent(new Event('change'))
    origFullValue = priceValue;
    if(addditionalCurrencyWrapp) {
        if(activeCurrency == 'BYN') {
            addditionalCurrencyWrapp.innerHTML = '';
        } else {
            addditionalCurrencyWrapp.innerHTML = ' / '+ new Intl.NumberFormat("ru-RU").format(price.value) + ' ' + activeCurrency;
        }
        
    }
}


initRates()

lessee?.forEach(item => item.addEventListener('change', switchLessee))
function switchLessee(e) {
    if(this.value === 'privat') {
        currensySelect.value = 'BYN'
        currensySelect.dispatchEvent(new Event('change'));
        disableOrEnableCurrency(true)
    } else {
        disableOrEnableCurrency(false)
    }

}
function disableOrEnableCurrency(disabled, exept = 'BYN') {
    let options = currensySelect.querySelectorAll('option')
    options?.forEach(item => {
        if(item.value !== exept) {
            item.disabled = disabled
            if(disabled) {
                item.classList.add('dnone')
            } else {
                item.classList.remove('dnone')
            }
        }
    })
}